module.exports = __webpack_public_path__ + "img/toothpasteModel.42146912.png";